<!--订单详情 孙猛 2020年10月30日15:41:55-->

<template>
  <div class="crew_right">
    <div class="conInner">
      <div class="orderInfo">
        <div class="top"></div>
        <div class="order_detail_wrapper">
          <!-- 订单号、订单状态 -->
          <div class="title">
            <h1>订单号：<span>{{info.sn}}</span></h1>
            <h2>订单状态:<span>{{info.statusText}}</span></h2>
            <div class="order_invoice">
            </div>
            <div class="button">
              <Button type="success" v-if="info.status===0" @click="playOrder">按此为订单付款</Button>
              <Button type="warning" v-if="(info.status === 0 || info.status === 2)&&aux !== 5"
                @click="showCancel">取消订单</Button>
              <Button type="success" v-if="info.status===5&&aux!==3&&aux!==4" @click="rogConfirm">确认收货</Button>
            </div>
          </div>
          <!-- 订单状态图解 -->
          <!--<div class="flow ">-->
          <!--<div :class="orderStatusImg"></div>-->
          <!--</div>-->
          <div class="receiver">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tbody>
                <tr>
                  <th>收货人信息</th>
                  <td>
                    <div><label>收货人:</label> <span>{{info.shipName}}</span></div>
                    <div v-if="info.shipMobile!==''"><label>手机:</label> <span>{{info.shipMobile}}</span></div>
                    <div v-if="info.shipTel!==''"><label>联系电话:</label> <span>{{info.shipTel}}</span></div>
                    <div><label>收货地址:</label> <span>{{info.shippingArea}}</span></div>
                    <div><label>邮编:</label> <span>{{info.shipZip}}</span></div>
                  </td>
                </tr>
                <tr>
                  <th>下单时间:</th>
                  <td>{{info.payTime}}</td>
                </tr>
                <tr>
                  <th>支付方式:</th>
                  <td>{{info.paymentName}}</td>
                </tr>
                <tr>
                  <th>订单附言:</th>
                  <td>{{info.remark}}</td>
                </tr>
                <tr>
                  <th>配送方式:</th>
                  <td>{{info.shippingType}}</td>
                </tr>
                <!--              <tr>-->
                <!--                <th>送货时间:</th>-->
                <!--                <td>{{info.ship_day}}&nbsp;{{info.ship_time}}</td>-->
                <!--              </tr>-->
                <tr>
                  <th>发货时间:</th>
                  <td>{{info.saleCmplTime}}</td>
                </tr>
                <tr>
                  <th>成交时间:</th>
                  <td>{{info.completeTime}}</td>
                </tr>
                <tr v-if="orderSn">
                  <th>退换物流公司名称:</th>
                  <td>{{info.logisticsCompanyName}}</td>
                </tr>
                <tr v-if="orderSn">
                  <th>退回物流单号:</th>
                  <td>{{info.logisticsSn}}</td>
                </tr>
                <tr v-if="orderSn">
                  <th>退回地址:</th>
                  <td>{{info.returnAddress}}</td>
                </tr>
                <tr v-if="orderSn&&info.status==3">
                  <th>拒绝原因:</th>
                  <td>{{info.refuseReason}}</td>
                </tr>
                <tr>
                  <th>发票抬头:</th>
                  <td>{{info.receiptPO.title}}</td>
                </tr>
                <tr>
                  <th>发票内容:</th>
                  <td>{{info.receiptPO.content}}</td>
                </tr>
                <tr v-if="info.status == 8">
                  <th>取消原因:</th>
                  <td>{{info.cancelReason}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="receiver" style="padding: 0 10px" v-if="info.dlvs">
            <h1 style="background-color: #eee;padding-left: 10px;font-size: 16px;">物流状态</h1>
            <div style="padding:10px;">
              <div style="padding:10px;">物流公司:{{info.dlvs.logiName}}</div>
              <div style="padding:10px;">货物单号:{{info.dlvs.logiNo}}</div>
            </div>
            <div class="order-track">
              <h1 style="background-color: #eee;padding-left: 10px;font-size: 16px;">运货状态</h1>
              <div class="track-list">
                <ul>
                  <li v-for="(item,index) in queryLogistics" :key='index'>
                    <i class="node-icon">
                      <i class="dot"></i>
                    </i>
                    <span class="time">{{item.time}}</span>
                    <span class="txt">{{item.status}}</span>
                  </li>
                </ul>
              </div>
              <div style="padding:10px;text-align: center" v-if="!queryLogistics.length">
                暂无信息
              </div>
            </div>
          </div>
          <div class="goodslist">
            <h1>商品清单</h1>
            <table cellspacing="0" cellpadding="0" width="100%">
              <thead>
                <tr>
                  <th>图片</th>
                  <th>商品名称</th>
                  <th>价格</th>
                  <th>数量</th>
                  <th>小计</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in info.items" :key="index">
                  <td>
                    <router-link target="_blank" :to="{path:'/goods',query:{goods_id:item.goodsId}}">
                      <span style="display: block; height: 50px;" class="cart-product-img">
                        <img :src="item.image" height="50" style="cursor: pointer;">
                      </span>
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{path:'/goods',query:{goods_id:item.goodsId}}" target="_blank" class="link blue">
                      {{item.name}}({{item.sn}})
                    </router-link>
                  </td>
                  <td>￥{{item.price.toFixed(2)}}</td>
                  <td>{{item.num}}</td>
                  <td>￥{{(item.num * item.price).toFixed(2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="total">
            <table cellspacing="0" cellpadding="0" border="0" width="100%">
              <tbody>
                <tr>
                  <th>商品总金额:</th>
                  <td>￥{{info.goodsAmount.toFixed(2)}}</td>
                </tr>
                <tr>
                  <th>配送费用:</th>
                  <td>￥{{info.shippingAmount.toFixed(2)}}</td>
                </tr>
                <tr>
                  <th>现金券:</th>
                  <td class="discount_green">￥{{info.userCoupon.toFixed(2)}}</td>
                </tr>
                <tr>
                  <th>优惠金额:</th>
                  <td class="discount_green">￥{{info.discount ? info.discount.toFixed(2) : 0}}</td>
                </tr>
                <tr>
                  <th>自营购物积分:</th>
                  <td class="discount_green">￥{{Number(info.selfShoppingPv).toFixed(2)}}</td>
                </tr>
                <tr>
                  <th>订单总金额:</th>
                  <td>￥{{info.orderAmount.toFixed(2)}}</td>
                </tr>
                <tr>
                  <th>已付金额:</th>
                  <td class="already_money">￥{{(info.paymoney?info.paymoney:0).toFixed(2)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="cancelModal" width="530" title="请输入取消原因">
      <Input v-model="reason" type="textarea" :rows="4" style="width:480px;" />
      <div slot="footer">
        <Button type="primary" size="large" @click.native="cancelOrder">确认取消订单</Button>
      </div>
    </Modal>
     <Modal v-model="frankingModal" width="530">
     <div style="padding: 24px; line-height: 1.5;font-size:16px">{{frankingText}}</div>
      <div slot="footer">
        <Button type="primary" size="large" @click.native="frankingHandle">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getOrderDetail, getOrderDetailBySn, orderCancel, rogConfirm, preCancelOrder, getLogistics } from 'api/order';
import { parseTime } from 'utils/tool';

export default {
  data() {
    return {
      cancelModal: false, // 取消原因弹框
      order_id: this.$route.query.orderId, // 取消的订单ID
      reason: '', // 订单取消理由
      orderStatusImg: 'status0',
      //
      orderId: this.$route.query.orderId,
      orderSn: this.$route.query.orderSn,
      isCod: this.$route.query.isCod,
      aux: this.$route.query.aux,
      info: {
        sn: '', // 订单编号
        status: '', // 订单状态
        statusText: '', // 订单状态文字
        shipName: '', // 收货人
        shippingArea: '', // 收货地址
        shipMobile: '', // 收货人手机
        shipTel: '', // 收货电话
        shipZip: '', // 配送邮政编码
        shippingType: '', // 配送方式
        paymentName: '', // 支付方式
        remark: '', // 订单附言
        shipDay: '', // 配送日期
        shipTime: '', // 配送时间
        returnAddress: '',//退回地址
        items: [], // 订单明细
        receiptPO: {
          title: '无', // 	发票抬头
          content: '无' // 发票内容
        },
        goodsAmount: 0, // 商品金额
        orderAmount: 0, // 订单总金额
        shippingAmount: 0, // 配送费用
        discount: 0, // 订单优惠金额
        paymoney: 0, // 	已支付金额
        userCoupon: 0, //现金券
        dlvs: {},//物流参数
        payTime: '',//下单时间
        saleCmplTime: '',//发货时间
        completeTime: '',//完成时间
        isSelf: "" // 是否自营  1 是自营
      },
      queryLogistics: [],//物流详情
      frankingText: '', //邮费提示
      frankingModal: false, // 邮费确认弹窗
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getOrderDetail();
    })
  },
  methods: {
    showCancel() {
      //判断是否自营订单然后弹出确认提示
      if (this.info.isSelf == 1) {
        preCancelOrder({ orderNo: this.info.sn }).then(({ resCode, resDesc, data }) => {
          if (resCode === 1) {
            if(data.message) {
              this.frankingText = data.message
              this.frankingModal = true
            } else {
              this.cancelModal = true
            }
          } else {
            this.cancelModal = false
            this.$Message.warning(resDesc);
          }
        })
      } else {
        this.cancelModal = true
      }
    },
    frankingHandle() {
      this.frankingModal = false
      this.cancelModal = true
    },

    // 查看订单详细
    getOrderDetail() {
      //根据传入参数的不同调用不同接口(orderId或orderSn)
      var callback = resp => {
        if (resp.resCode === 1) {
          this.info = resp.data;
          console.log(this.info, 'this.info-------------');
          //格式化时间
          this.info.payTime = parseTime(this.info.payTime);
          this.info.saleCmplTime = parseTime(this.info.saleCmplTime);
          this.info.orderId = this.info.orderId || this.orderId;
          this.info.dlvs = resp.data.dlvs[0];
          if (this.info.completeTime == 0) {
            this.info.completeTime = null
          } else {
            this.info.completeTime = parseTime(this.info.completeTime)
          }
          if (!this.info.userCoupon) this.info.userCoupon = 0;
          if (!this.info.shippingAmount) this.info.shippingAmount = 0;
          if (!this.info.discount) this.info.discount = 0;

          if (!this.orderId) { this.orderId = this.info.orderId; }
          this.orderStatusImg = `statu${this.info.status}`;
          if (resp.data.receiptPO === null) {
            this.info.receiptPO = {
              title: '无', // 	发票抬头
              content: '无' // 发票内容
            }
          }
          let _params = { "orderNo": this.orderSn };
          getLogistics(_params).then(resp => {
            if (resp.resCode === 1) {
              this.queryLogistics = resp.data.traces.reverse();
            }
          })
        } else {
          this.$Message.error("查看订单失败!");
          setTimeout(() => {
            this.$router.push({
              path: '/member/order'
            })
          }, 500)
        }
      }
      if (this.orderId) {
        getOrderDetail({ orderNo: this.orderSn }).then(callback);
      } else if (this.orderSn) {
        getOrderDetailBySn({ orderNo: this.orderSn }).then(callback);
      }
    },
    //
    playOrder() {
      let routeData = this.$router.resolve({ path: '/pay', query: { orderId: this.orderId, orderNo: this.info.sn } });
      const tempwindow = window.open();
      tempwindow.location = routeData.href;
    },
    // 订单确认收货
    rogConfirm() {
      this.$Modal.confirm({
        content: '<p>请您确认已经收到货物再执行此操作！</p>',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          rogConfirm({ orderNo: this.info.sn }).then(resp => {
            if (resp.resCode === 1) {
              this.$Modal.success({
                content: '订单已确认收货!',
                onOk: () => {
                  this.$router.go(0);
                }
              });
            } else {
              this.$Message.error(resp.resDesc);
            }
          })
        },
        onCancel: () => {
        }
      });
    },
    // 取消订单
    cancelOrder() {
      setTimeout(() => {
        if (this.reason.trim() === '') {
          this.$Message.warning('订单取消原因不能为空');
        } else {
          orderCancel({
            orderNo: this.orderSn,
            reason: this.reason
          }).then(resp => {
            if (resp.resCode === 1) {
              setTimeout(() => {
                this.cancelModal = false;
              }, 500);
              this.$Modal.success({
                content: '订单取消成功!',
                onOk: () => {
                  this.$router.go(0);
                }
              });
            } else {
              this.reason = '';
              this.$Message.error(resp.resDesc);
            }
          })
        }
      })
    },
  }
}
</script>
<style scoped>
.orderInfo {
  float: left;
  position: relative;
  z-index: 1;
  top: 0;
}

.orderInfo .top {
  width: 753px;
  height: 8px;
  background: url(//static.kxymall.com/images/hylyt.jpg) no-repeat left top;
  overflow: hidden;
}

.orderInfo .order_detail_wrapper {
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  background-color: #ffffff;
  width: 751px;
}

.orderInfo .order_detail_wrapper .title {
  height: 40px;
  background-color: #eee;
  border-bottom: 1px solid #d2dcdb;
  overflow: hidden;
}

.orderInfo .order_detail_wrapper .title h1 {
  background-color: transparent;
  float: left;
  display: inline;
  margin: 0 15px 0 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: normal;
  color: #6c6c6c;
}

.orderInfo .order_detail_wrapper .title h1 span {
  margin: 0 5px;
  font-weight: bold;
  color: #000;
}

.orderInfo .order_detail_wrapper .title h2 {
  float: left;
  display: inline;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: normal;
  color: #6c6c6c;
}

.orderInfo .order_detail_wrapper .title h2 span {
  margin: 0 5px;
  font-weight: bold;
  color: #000;
}

.orderInfo .order_detail_wrapper .title .button {
  float: right;
  margin-right: 10px;
}

/***订单状态图  先付款后发货***/
.orderInfo .order_detail_wrapper .flow .status7 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfukuan.jpg) no-repeat left -473px;
}

.orderInfo .order_detail_wrapper .flow .status6 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfukuan.jpg) no-repeat left -380px;
}

.orderInfo .order_detail_wrapper .flow .status5 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfukuan.jpg) no-repeat left -285px;
}

.orderInfo .order_detail_wrapper .flow .status4 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfukuan.jpg) no-repeat left -190px;
}

.orderInfo .order_detail_wrapper .flow .status3 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfukuan.jpg) no-repeat left -190px;
}

.orderInfo .order_detail_wrapper .flow .status2 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfukuan.jpg) no-repeat left -95px;
}

.orderInfo .order_detail_wrapper .flow .status1 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfukuan.jpg) no-repeat left top;
}

.orderInfo .order_detail_wrapper .flow .status0 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfukuan.jpg) no-repeat left top;
}

/***订单状态图  先发货后付款***/
.orderInfo .order_detail_wrapper .flow .statusway7 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfahuo.jpg) no-repeat left -380px;
}

.orderInfo .order_detail_wrapper .flow .statusway6 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfahuo.jpg) no-repeat left -184px;
}

.orderInfo .order_detail_wrapper .flow .statusway5 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfahuo.jpg) no-repeat left -85px;
}

.orderInfo .order_detail_wrapper .flow .statusway4 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfahuo.jpg) no-repeat left -190px;
}

.orderInfo .order_detail_wrapper .flow .statusway3 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfahuo.jpg) no-repeat left -190px;
}

.orderInfo .order_detail_wrapper .flow .statusway2 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfahuo.jpg) no-repeat left -95px;
}

.orderInfo .order_detail_wrapper .flow .statusway1 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfahuo.jpg) no-repeat left top;
}

.orderInfo .order_detail_wrapper .flow .statusway0 {
  height: 89px;
  background: url(//static.kxymall.com/images/xianfahuo.jpg) no-repeat left top;
}

/**订单日志**/
.orderInfo .order_detail_wrapper .log ol {
  overflow: hidden;
  background-color: #fff;
  padding-left: 67px;
}

.orderInfo .order_detail_wrapper .log ol li {
  float: left;
  display: inline;
  width: 686px;
  line-height: 25px;
}

/**收货人信息**/
.orderInfo .order_detail_wrapper .receiver {
  overflow: hidden;
  padding: 30px 0px;
  background-color: #fff;
}

.orderInfo .order_detail_wrapper .receiver table {
  border: 0 none;
}

.orderInfo .order_detail_wrapper .receiver table tr th {
  padding: 5px 0;
  width: 18%;
  background-color: #fff;
  text-align: right;
  border: 0 none;
  vertical-align: top;
}

.orderInfo .order_detail_wrapper .receiver table tr td {
  padding: 5px 0 5px 26px;
  border: 0 none;
  text-align: left;
}

.orderInfo .order_detail_wrapper .receiver table tr td ul {
  width: 100%;
}

.orderInfo .order_detail_wrapper .receiver table tr td ul li {
  line-height: 25px;
  height: 25px;
}

.orderInfo .order_detail_wrapper .receiver table tr td ul li label {
  margin-right: 10px;
}

.orderInfo .order_detail_wrapper .goodslist {
  padding: 0 10px;
}

.orderInfo .order_detail_wrapper .goodslist td {
  border-bottom: 1px dotted #dbdbdb;
}

.orderInfo .order_detail_wrapper h1 {
  color: #333;
  height: 38px;
  line-height: 38px;
  background-color: #fff;
  padding-left: 0;
}

.orderInfo .goodslist table .hovertr td {
  padding: 10px 0;
}

.orderInfo .goodslist table th {
  height: 31px;
  line-height: 31px;
  border-bottom: 1px solid #dbdbdb;
  background-color: #eee;
  text-align: center;
}

.orderInfo .goodslist table .last td {
  border: 0px none;
}

.orderInfo .goodslist table td {
  border-bottom: 1px dotted #dbdbdb;
  height: 31px;
  line-height: 31px;
  text-align: center;
  background-color: #fff;
}

.orderInfo .order_detail_wrapper .total {
  clear: both;
  overflow: hidden;
  background-color: #fff;
}

.orderInfo .order_detail_wrapper .total table {
  width: 210px;
  float: right;
  border: 0 none;
}

.orderInfo .order_detail_wrapper .total table tr th {
  height: 25px;
  line-height: 25px;
  border: 0px none;
  width: 100px;
  text-align: right;
  padding-right: 10px;
  background-color: #fff;
  font-weight: normal;
}

.orderInfo .order_detail_wrapper .total table tr td {
  text-align: left;
  border: 0 none;
  height: 25px;
  line-height: 25px;
}

.orderInfo .order_detail_wrapper .total table tr .discount_green {
  color: #13ba2c;
}

.orderInfo .order_detail_wrapper .total table tr .already_money {
  color: #dd5d3a;
  font-size: 16px;
}
.order-track .track-list {
  margin: 10px;
  height: 216px;
  padding-left: 5px;
  overflow-y: auto;
  position: relative;
}
.order-track .track-list li {
  position: relative;
  padding: 9px 0 0 15px;
  line-height: 22px;
}
.order-track .track-list li .node-icon {
  position: absolute;
  left: 140px;
  top: 0;
  width: 19px;
  height: 100%;
  background: url("../../../assets/images/track-node.png") -90px 0 #fff repeat-y;
}
.order-track .track-list li .node-icon .dot {
  display: inline-block;
  vertical-align: top;
  width: 19px;
  height: 19px;
  margin-top: 10px;
  background: url("../../../assets/images/track-node.png") -60px 0 no-repeat;
  overflow: hidden;
}
.order-track .track-list li .time {
  width: 120px;
  margin-right: 20px;
}
.order-track .track-list li .txt {
  margin-left: 30px;
  max-width: 505px;
  vertical-align: top;
  position: relative;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// orderInfo.vue?19f338df